import { render, staticRenderFns } from "./StaticAlertComponent.vue?vue&type=template&id=8d2e759c&scoped=true"
import script from "./StaticAlertComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaticAlertComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StaticAlertComponent.vue?vue&type=style&index=0&id=8d2e759c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2e759c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d2e759c')) {
      api.createRecord('8d2e759c', component.options)
    } else {
      api.reload('8d2e759c', component.options)
    }
    module.hot.accept("./StaticAlertComponent.vue?vue&type=template&id=8d2e759c&scoped=true", function () {
      api.rerender('8d2e759c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alert/StaticAlertComponent.vue"
export default component.exports